var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('dialog-base-skeleton',{attrs:{"title":`${this.$t('dialog.export')}`},on:{"close":_vm.closePopUp},scopedSlots:_vm._u([{key:"contents",fn:function(){return [_c('base-form',{attrs:{"fields":_vm.fields,"submit":_vm.handleSubmit,"submit-btn-title":() => 'export'},on:{"cancel":_vm.closePopUp}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }